module.exports = __webpack_public_path__ + "static/media/pastordocas.df599cdf.jpg";